<template>
	<div>
		<!-- 单条发货弹窗 -->
		<c-dialog ref="dialog" title="发货" width="600">
			<div class="m-ship-body">
				<div class="m-ship-product">
					<div v-if="!productVerified" class="m-ship-product-scan">-</div>
					<template v-else>
						<div class="m-ship-product-name">
							<c-state v-if="shipForm.levelType" tag dict="LEVEL_TYPE" :value="shipForm.levelType"></c-state>
							<span>{{productText || '-'}}</span>
						</div>
						<div class="m-ship-product-info">
							<span v-if="shipForm.produceCode">背贴码：{{shipForm.produceCode}}</span>
							<span v-if="shipForm.imei">IMEI：{{shipForm.imei}}</span>
							<span v-if="shipForm.channelName">销售渠道：{{shipForm.channelName}}</span>
						</div>
					</template>
				</div>

				<div class="m-ship-form">
					<div class="m-ship-form-item">
						<div class="m-ship-label"><span class="m-required">*</span>产品背贴码</div>
						<c-input ref="stickerInput" v-model="shipForm.produceCode" placeholder="请扫描/输入背贴码" @keyup.enter.native="verifyProduceCode(false)" @blur="verifyProduceCode(true)">
                            <template #appendIcon><i class="tf-scan"></i></template>
                        </c-input>
					</div>

					<div class="m-ship-form-item">
						<div class="m-ship-label">第三方质检码</div>
						<c-input ref="qcInput" v-model="shipForm.qcCode" :disabled="!productVerified" placeholder="请先扫描产品背贴码">
                            <template #appendIcon><i class="tf-scan"></i></template>
                        </c-input>
					</div>

					<div class="m-ship-form-item">
						<div class="m-ship-label"><span class="m-required">*</span>快递单号</div>
						<div class="m-ship-radio">
							<c-radio-group v-model="shipForm.shipType">
								<c-radio value="manual">手动录入</c-radio>
								<c-radio value="electronic">电子面单</c-radio>
							</c-radio-group>
						</div>

						<div v-if="shipForm.shipType == 'manual'" class="m-ship-express">
							<c-select v-model="shipForm.expressCompanyCode" async @search="searchLogisticsCompany" :value-data="selectedExpressCompanyData" placeholder="快递公司" @change="changeExpressCompany"></c-select>
							<c-input v-model="shipForm.expressNo" placeholder="请输入运单号"></c-input>
						</div>

						<div v-else class="m-ship-electronic">
							<div class="m-waybill-address">
								<div class="m-waybill-address-header">
									<div class="m-waybill-label">
										<span class="m-required">*</span>
										<span>发货地址</span>
									</div>
									<c-link v-if="selectedAddress" @click="openAddressSelect">选择地址</c-link>
								</div>
								<div v-if="selectedAddress" class="m-address-selected">
									<p class="m-address-info">{{selectedAddress.full_address}}</p>
									<p class="m-address-contact">{{selectedAddress.name}} {{selectedAddress.phone}}</p>
								</div>
								<div v-else class="m-address-empty"><c-link @click="openAddressSelect">请选择发货地址</c-link></div>
							</div>

							<div class="m-waybill-selector">
								<div class="m-waybill-label">
									<span class="m-required">*</span>
									<span>请选择电子面单</span>
								</div>
								<div class="m-waybill-options">
									<div
										v-for="item in waybillOptions"
										:key="item.value"
										:class="['m-waybill-option', { 'm-active': selectedWaybill === item.value }]"
										@click="selectedWaybill = item.value"
									>
										<div class="m-waybill-content">
											<div v-if="item.logo" class="m-waybill-logo" :style="{color: item.color}">{{item.logo}}</div>
											<div class="m-waybill-name">{{item.name}}</div>
										</div>
										<div v-if="selectedWaybill === item.value" class="m-waybill-check">
											<i class="tf tf-check"></i>
										</div>
									</div>
								</div>
							</div>

							<div v-if="selectedWaybill === 'DL'" class="m-waybill-logistics">
								<div class="m-waybill-label">
									<span class="m-required">*</span>
									<span>请选择物流公司</span>
								</div>
								<c-select v-model="selectedLogisticsType" async @search="searchLogisticsCompany" :value-data="selectedLogisticsTypeData" placeholder="请选择物流公司" @change="changeLogisticsType"></c-select>
							</div>
						</div>
					</div>
				</div>
			</div>

			<template #button>
				<c-button v-if="shipForm.shipType == 'electronic'" size="dialog" color="main" :disabled="!canApplyElectronic" @click="applyElectronicWaybill">打印电子面单</c-button>
				<c-button size="dialog" color="main" :disabled="!canSubmitShip" @click="submitShip">确认发货</c-button>
				<c-button size="dialog" @click="closeDialog">取消</c-button>
			</template>
		</c-dialog>

		<!-- 选择发货地址弹窗 -->
		<c-dialog ref="addressSelectDialog" title="选择发货地址" width="560">
			<div class="m-address-list">
				<div class="m-address-tip">
					<i class="tf-deliver"></i>点击选择发货地址
				</div>
				<div
					v-for="item in addressList"
					:key="item.id"
					:class="['m-address-item', {'m-active': selectedAddress && selectedAddress.id == item.id}]"
					@click="selectAddress(item)"
				>
					<div class="m-address-item-info">
						<p class="m-address-item-text"><i class="tf-address"></i>{{item.full_address}}</p>
						<p class="m-address-item-contact">
							<span class="m-contact-item"><i class="tf-username"></i>{{item.name}}</span>
							<span class="m-contact-item"><i class="tf-phone"></i>{{item.phone}}</span>
						</p>
					</div>
					<span v-if="item.is_default == 1" class="m-address-item-tag">默认</span>
					<span class="m-address-item-arrow"><i class="tf-angle-right"></i></span>
					<span class="m-address-item-check"><i class="tf-check"></i></span>
				</div>
				<div v-if="!addressList.length" class="m-address-empty">
					<img class="m-address-empty-img" src="~@/assets/image/empty.png" alt="">
					<p class="m-address-empty-text">暂无发货地址</p>
				</div>
			</div>

			<template #button>
				<c-button size="dialog" @click="$refs.addressSelectDialog.close()">关闭</c-button>
			</template>
		</c-dialog>

	</div>
</template>

<script>
	export default {
		name: 'saleShipDialog',

		data() {
			return {
				productVerified: false,
				verifiedCode: '',
				/*已选快递公司完整项[{name, value}]，用于async下拉的值回显*/
				selectedExpressCompanyData: [],
				shipForm: {
					orderId: '',
					deliveryId: '',
					orderNo: '',
					productName: '',
					channelName: '',
                    produceCode: '',
					/*扫码校验回写的条码属性，用于展示品牌/型号/内存/颜色/等级完整信息*/
					brandName: '',
					modelName: '',
					memoryName: '',
					colorName: '',
					levelType: '',
					imei: '',
					qcCode: '',
					shipType: 'manual',
					expressNo: '',
					expressCompanyCode: '',
					expressCompanyName: ''
				},
				addressList: [],
				selectedAddress: null,
				selectedWaybill: '',
				selectedLogisticsType: '',
				waybillOptions: [
					{value: 'JD', name: '京东', logo: 'JDL', color: '#e1251b', code: 20001},
					{value: 'SF', name: '顺丰', logo: 'SF', color: '#333333', code: 20002},
					{value: 'DL', name: '鼎霖电子面单', logo: '', color: ''}
				],
				/*已选物流公司完整项[{name, value}]，用于async下拉的值回显与取递交名称*/
				selectedLogisticsTypeData: []
			}
		},

		computed: {
			/*********扫码校验后的完整商品名称：与列表 getProductText 同口径（品牌+型号+内存+颜色），条码属性缺失时兜底订单存量商品名**********/
			productText() {
				var parts = [];
				if (this.shipForm.brandName) parts.push(this.shipForm.brandName);
				if (this.shipForm.modelName) parts.push(this.shipForm.modelName);
				if (this.shipForm.memoryName) parts.push(this.shipForm.memoryName);
				if (this.shipForm.colorName) parts.push(this.shipForm.colorName);
				return parts.join(' ') || this.shipForm.productName;
			},

			/*********是否可以提交发货**********/
			canSubmitShip() {
				if (!this.productVerified) return false;
				if (this.shipForm.shipType == 'electronic') {
                    if (this.shipForm.providerCode == this.selectedWaybill && this.shipForm.electronicExpressNo.trim()) {
                        if (this.selectedWaybill == 'JD' || this.selectedWaybill == 'SF') {
                            return true;
                        } else if (this.selectedWaybill == 'DL' && this.shipForm.electronicExpressCompanyCode == this.selectedLogisticsType) {
                            return true;
                        }
                    }
                    return false;
				}
				return true;
			},

			/*********是否可以申请电子面单**********/
			canApplyElectronic() {
				if (!this.selectedAddress || !this.selectedWaybill) return false;
				if (this.selectedWaybill === 'DL' && !this.selectedLogisticsType) return false;
				return true;
			}
		},

		watch: {
			'shipForm.produceCode'(val) {
				// 验证成功回写背贴码时保持验证状态，值变化后才需重新验证
				if ((val || '').trim() == this.verifiedCode) return;
				this.productVerified = false;
			}
		},

		methods: {
			/*********打开弹框**********/
			open(data = {}) {
				this.shipForm = {
                    orderId: data.orderId,
                    deliveryId: data.deliveryId || '',
                    orderNo: data.orderNo || '',
                    productName: '',
                    produceCode: '',
                    channelName: '',
                    brandName: '',
                    modelName: '',
                    memoryName: '',
                    colorName: '',
                    levelType: '',
                    imei: '',
                    qcCode: '',
                    shipType: (data.waybillType && data.waybillType == 1) ? 'electronic' : 'manual',
                    expressNo: '',
                    expressCompanyCode: '',
                    expressCompanyName: '',
                    electronicExpressNo: data.deliveryExpressNo || '',
                    electronicExpressCompanyCode: data.deliveryCompanyCode || '',
                    electronicExpressCompanyName: data.deliveryCompany || '',
                    providerCode: data.providerCode || ''
                }
				this.productVerified = false;
				this.verifiedCode = '';
				this.selectedWaybill = data.providerCode || '';
				this.selectedLogisticsType = data.providerCode == 'DL' ? data.deliveryCompanyCode : '';
				/*async下拉用value-data回显已选物流公司名称*/
				this.selectedLogisticsTypeData = this.selectedLogisticsType ? [{name: this.shipForm.electronicExpressCompanyName || String(this.selectedLogisticsType), value: this.selectedLogisticsType}] : [];
				/*手动录单快递公司无历史回显值，重置异步下拉选中项*/
				this.selectedExpressCompanyData = [];
				this.selectedAddress = null;
				this.loadAddressList();
				this.$refs.dialog.open();
				this.focusStickerInput();
			},

			/*********切换快递公司时同步名称（async下拉change回传完整选中项，清除时为空对象）**********/
			changeExpressCompany(data) {
				var valid = data && data.value !== undefined;
				this.selectedExpressCompanyData = valid ? [data] : [];
				this.shipForm.expressCompanyName = valid ? (data.name || '') : '';
			},

			/*********异步搜索快递/物流公司（LOGISTICS_TYPE字典，两个下拉共用，keyword映射后端name模糊查询）**********/
			searchLogisticsCompany(keyword, resolve) {
				this.request({
					url: '/dic/info/options',
					data: {
						dic_type_code: 'LOGISTICS_TYPE',
						name: keyword
					},
					success: data => {
						resolve(data || []);
					}
				});
			},

			/*********选中/清除物流公司时同步完整项（清除时change回传空对象，置空避免回填）**********/
			changeLogisticsType(data) {
				this.selectedLogisticsTypeData = (data && data.value !== undefined) ? [data] : [];
			},

			/*********扫描背贴码校验商品信息（接口预留）**********/
			// silentWhenEmpty: true=失焦触发（空值静默），false=回车触发（空值提示）
			verifyProduceCode(silentWhenEmpty) {
				var produceCode = this.shipForm.produceCode.trim();
				if (!produceCode) {
					if (!silentWhenEmpty) {
						this.$message({message: '请扫描/输入产品背贴码', type: 'warning'});
					}
					this.productVerified = false;
					return;
				}

				// 同一个码已验证通过不重复查询（回车验证后失焦会再次触发）
				if (this.productVerified && produceCode == this.verifiedCode) {
					return;
				}

				this.request({
					url: '/sale/delivery/scan/verify_product',
					data: {
						order_id: this.shipForm.orderId,
						produce_code: produceCode
					},
					loading: true,
					success: (data) => {
						this.productVerified = true;
						this.shipForm.productName = (data && data.product_name) || '';
						this.shipForm.produceCode = (data && data.produce_code) || '';
						this.verifiedCode = this.shipForm.produceCode;
						this.shipForm.channelName = (data && data.channel_name) || '';
						this.shipForm.brandName = (data && data.brand_name) || '';
						this.shipForm.modelName = (data && data.model_name) || '';
						this.shipForm.memoryName = (data && data.memory_name) || '';
						this.shipForm.colorName = (data && data.color_name) || '';
						this.shipForm.levelType = (data && data.level_type) || '';
						this.shipForm.imei = (data && data.imei) || '';
						// 订单商品自带三方质检码时默认带入，允许用户删除后重新扫描
						this.shipForm.qcCode = (data && data.third_party_quality_code) || '';
						this.focusQcInput();
					},
					fail: (msg) => {
						this.productVerified = false;
						this.verifiedCode = '';
						this.shipForm.produceCode = '';
						this.shipForm.productName = '';
						this.shipForm.channelName = '';
						this.shipForm.brandName = '';
						this.shipForm.modelName = '';
						this.shipForm.memoryName = '';
						this.shipForm.colorName = '';
						this.shipForm.levelType = '';
						this.shipForm.imei = '';
						this.shipForm.qcCode = '';
						this.focusStickerInput();
						this.$message({message: msg || '商品不存在或不属于当前订单，请检查', type: 'warning'});
					}
				});
			},

			/*********聚焦背贴码输入框**********/
			focusStickerInput() {
				this.$nextTick(() => {
					var input = this.$refs.stickerInput && this.$refs.stickerInput.$el.querySelector('input');
					if (input) input.focus();
				});
			},

			focusQcInput() {
				this.$nextTick(() => {
					var input = this.$refs.qcInput && this.$refs.qcInput.$el.querySelector('input');
					if (input) input.focus();
				});
			},

			/*********确认发货**********/
			submitShip() {
				if (!this.productVerified) {
					this.$message({message: '请先扫描验证产品背贴码', type: 'warning'});
					return;
				}

				var produceCode = this.shipForm.produceCode.trim();
				if (!produceCode) {
					this.$message({message: '请输入产品背贴码', type: 'warning'});
					return;
				}

				if (this.shipForm.shipType == 'manual') {
					if (!this.shipForm.expressNo.trim()) {
						this.$message({message: '请输入运单号', type: 'warning'});
						return;
					}
					if (!this.shipForm.expressCompanyCode) {
						this.$message({message: '请选择快递公司', type: 'warning'});
						return;
					}
				} else {
					if (!this.shipForm.electronicExpressNo.trim()) {
						this.$message({message: '请先打印电子面单', type: 'warning'});
						return;
					}
				}

				this.confirmShip();
			},

			/*********统一调用确认发货接口**********/
			confirmShip() {
				this.request({
					url: '/sale/delivery/order/ship',
					data: {
						order_id: this.shipForm.orderId,
						produce_code: this.shipForm.produceCode.trim(),
						third_party_quality_code: this.shipForm.qcCode.trim(),
						express_no: this.shipForm.shipType == 'electronic' ? this.shipForm.electronicExpressNo : this.shipForm.expressNo.trim(),
						express_company_code: this.shipForm.shipType == 'electronic' ? this.shipForm.electronicExpressCompanyCode : this.shipForm.expressCompanyCode,
						express_company: this.shipForm.shipType == 'electronic' ? this.shipForm.electronicExpressCompanyName : this.shipForm.expressCompanyName,
						waybill_type: this.shipForm.shipType == 'electronic' ? 1 : 2,
                        provider_code: this.selectedWaybill || ''
					},
					loading: true,
					success: (data, msg) => {
						this.$message({message: msg || '发货成功', type: 'success'});
						this.$refs.dialog.close();
						this.$emit('resolve');
					}
				});
			},

			/*********加载发货地址列表**********/
			loadAddressList() {
				this.request({
					url: '/sys_saas/address/list/noPage',
					data: {
						address_type: 1,
                        is_enable: 1
					},
					success: data => {
						this.addressList = data || [];
						if (this.selectedAddress) {
							var updated = this.addressList.find(item => item.id == this.selectedAddress.id);
							if (updated) {
								this.selectedAddress = updated;
							}
						}
						if (!this.selectedAddress) {
							//默认选中默认地址，无默认地址时选中第一条
							this.selectedAddress = this.addressList.find(item => item.is_default == 1) || this.addressList[0];
						}
					}
				});
			},

			/*********打开选择发货地址弹窗**********/
			openAddressSelect() {
				this.loadAddressList();
				this.$refs.addressSelectDialog.open();
			},

			/*********选择发货地址**********/
			selectAddress(item) {
				this.selectedAddress = item;
				this.$refs.addressSelectDialog.close();
			},

			/*********申请并打印电子面单**********/
			applyElectronicWaybill() {
				if (!this.canApplyElectronic) {
					this.$message({message: '请选择发货地址和电子面单', type: 'warning'});
					return;
				}
				var providerCode = this.selectedWaybill;
				var expressCompanyCode = '';
				var expressCompany = '';
				if (this.selectedWaybill === 'DL') {
					if (!this.selectedLogisticsType) {
						this.$message({message: '请选择物流公司', type: 'warning'});
						return;
					}
					var selectedLogisticsOption = this.selectedLogisticsTypeData[0];
					expressCompanyCode = this.selectedLogisticsType;
					expressCompany = selectedLogisticsOption ? selectedLogisticsOption.name : '';
				} else {
					var waybillOption = this.waybillOptions.find(item => item.value == this.selectedWaybill);
					expressCompanyCode = waybillOption ? waybillOption.code : '';
					expressCompany = waybillOption ? waybillOption.name : '';
				}
				this.request({
					url: '/sale/delivery/one/applyAndPrint',
					responseType: 'blob',
					data: {
						provider_code: providerCode,
						delivery_id: this.shipForm.deliveryId,
						order_id: this.shipForm.orderId,
						address_id: this.selectedAddress.id,
						express_company_code: expressCompanyCode,
						express_company: expressCompany
					},
					loading: true,
					success: async response => {
						var pdfBlob = response.data;
						if (!pdfBlob || pdfBlob.type.indexOf('application/pdf') !== 0) {
							this.readWaybillError(pdfBlob);
							return;
						}
						var responseHeaders = response.headers || {};
						var waybillNo = responseHeaders['x-waybill-no'] || responseHeaders['X-Waybill-No'];
						if (!waybillNo) {
							this.$message({message: '电子面单申请成功，但后端未返回运单号', type: 'warning'});
							return;
						}

						this.shipForm.electronicExpressNo = waybillNo;
						this.shipForm.electronicExpressCompanyCode = expressCompanyCode;
						this.shipForm.electronicExpressCompanyName = expressCompany;
						this.shipForm.providerCode = this.selectedWaybill;

						try {
							await this.printPdf(pdfBlob);
						} catch (error) {
							console.error('电子面单打印失败：', error);
							this.$message({message: error.message || '电子面单打印失败', type: 'warning'});
							return;
						}

						this.$message({message: '电子面单申请成功', type: 'success'});
						this.$emit('resolve');
					}
				});
			},

			readWaybillError(blob) {
				if (!blob) {
					this.$message({message: '电子面单打印失败', type: 'warning'});
					return;
				}
				var reader = new FileReader();
				reader.onload = () => {
					try {
						var result = JSON.parse(reader.result);
						this.$message({message: result.message || '电子面单打印失败', type: 'warning'});
					} catch (e) {
						this.$message({message: '电子面单打印失败', type: 'warning'});
					}
				};
				reader.readAsText(blob);
			},

			/*********通过PDF数据流唤起浏览器打印**********/
			printPdf(pdfBlob) {
				return new Promise((resolve, reject) => {
					var objectUrl = URL.createObjectURL(pdfBlob);
					var iframe = document.createElement('iframe');
					var loadTimer;
					var cleanTimer;
					var cleaned = false;

					var cleanup = () => {
						if (cleaned) return;
						cleaned = true;
						clearTimeout(loadTimer);
						clearTimeout(cleanTimer);
						if (iframe.parentNode) {
							iframe.parentNode.removeChild(iframe);
						}
						URL.revokeObjectURL(objectUrl);
					};

					iframe.style.position = 'fixed';
					iframe.style.left = '-10000px';
					iframe.style.top = '0';
					iframe.style.width = '1px';
					iframe.style.height = '1px';
					iframe.style.border = '0';

					iframe.onload = () => {
						clearTimeout(loadTimer);
						setTimeout(() => {
							try {
								var printWindow = iframe.contentWindow;
								printWindow.addEventListener('afterprint', cleanup, {once: true});
								printWindow.focus();
								printWindow.print();
								cleanTimer = setTimeout(cleanup, 60000);
								resolve(true);
							} catch (error) {
								cleanup();
								reject(new Error('无法唤起PDF打印窗口'));
							}
						}, 300);
					};

					iframe.src = objectUrl;
					document.body.appendChild(iframe);

					loadTimer = setTimeout(() => {
						cleanup();
						reject(new Error('PDF打印文件加载超时'));
					}, 15000);
				});
			},

			/*********关闭弹框**********/
			closeDialog() {
				this.$refs.dialog.close();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-required {
		color: #e53e3e;
		margin-right: 2px;
	}

	// 发货弹窗
	.m-ship-body {
		padding: 20px;

		.m-ship-product {
			background: #f5f7ff;
			border-radius: 4px;
			padding: 16px;
			text-align: center;
			margin-bottom: 20px;

			.m-ship-product-scan {
				color: #999;
				font-size: 14px;
				font-weight: 700;
				line-height: 1.5;
			}

			.m-ship-product-name {
				color: #3D5EFF;
				font-size: 15px;
				font-weight: bold;
				margin-bottom: 8px;
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 4px;
			}

			.m-ship-product-info {
				color: #666;
				font-size: 12px;
				display: flex;
				justify-content: center;
				gap: 12px;
				flex-wrap: wrap;
			}
		}

		.m-ship-form-item {
			margin-bottom: 16px;

			.m-ship-label {
				font-size: 13px;
				color: #333;
				margin-bottom: 8px;
				display: flex;
				align-items: center;
			}

			.m-ship-radio {
				display: flex;
				gap: 20px;
				margin-bottom: 10px;

				.m-ship-radio-item {
					display: flex;
					align-items: center;
					gap: 6px;
					cursor: pointer;
					font-size: 13px;
					color: #666;

					i {
						width: 14px;
						height: 14px;
						border-radius: 50%;
						border: 1px solid #ccc;
						display: inline-block;
						position: relative;
					}

					&.m-active {
						color: #333;

						i {
							border-color: #3D5EFF;

							&::after {
								content: '';
								position: absolute;
								left: 3px;
								top: 3px;
								width: 6px;
								height: 6px;
								border-radius: 50%;
								background: #3D5EFF;
							}
						}
					}
				}
			}

			.m-ship-express {
				display: flex;
				gap: 10px;

				.m-ship-express-input {
					flex: 1;
				}
			}
		}
	}

	// 电子面单地址/面单选择
	.m-ship-electronic {
		padding-top: 4px;

		.m-waybill-address {
			margin-bottom: 16px;

			.m-waybill-address-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 8px;
			}

			.m-waybill-label {
				font-size: 13px;
				color: #333;
				display: flex;
				align-items: center;
			}

			.m-address-selected {
				background: #f5f7ff;
				border-radius: 4px;
				padding: 10px 12px;

				.m-address-info {
					font-size: 13px;
					color: #333;
					line-height: 1.5;
					margin-bottom: 4px;
				}

				.m-address-contact {
					font-size: 12px;
					color: #666;
				}
			}

			.m-address-empty {
				color: #999;
				font-size: 13px;
				padding: 10px 0;
			}
		}

		.m-waybill-selector {
			margin-bottom: 16px;

			.m-waybill-label {
				font-size: 13px;
				color: #333;
				display: flex;
				align-items: center;
				margin-bottom: 8px;
			}

			.m-waybill-options {
				display: flex;
				gap: 10px;
				flex-wrap: wrap;
			}

			.m-waybill-option {
				width: 140px;
				border: 1px solid #e5e5e5;
				border-radius: 4px;
				padding: 10px;
				cursor: pointer;
				position: relative;
				background: #fff;

				&.m-active {
					border-color: #3D5EFF;
					background: #f5f7ff;
				}

				.m-waybill-content {
					display: flex;
					align-items: center;
					gap: 8px;

					.m-waybill-logo {
						font-weight: bold;
						font-size: 14px;
					}

					.m-waybill-name {
						font-size: 13px;
						color: #333;
					}
				}

				.m-waybill-check {
					position: absolute;
					right: 6px;
					top: 11px;
					color: #3D5EFF;
					font-size: 12px;
				}
			}
		}

		.m-waybill-logistics {
			margin-bottom: 16px;
	
			.m-waybill-label {
				font-size: 13px;
				color: #333;
				display: flex;
				align-items: center;
				margin-bottom: 8px;
			}
		}
	}

	// 选择发货地址弹窗
	.m-address-list {
		padding: 4px 16px 12px;
		min-height: 150px;
		max-height: 400px;
		overflow-y: auto;

		.m-address-tip {
			display: flex;
			align-items: center;
			margin-bottom: 12px;
			padding: 8px 12px;
			font-size: 13px;
			color: #1890ff;
			background: #e6f7ff;
			border: 1px solid #91d5ff;
			border-radius: 4px;

			.tf {
				margin-right: 6px;
			}
		}

		.m-address-item {
			position: relative;
			display: flex;
			align-items: center;
			padding: 14px 44px 14px 16px;
			margin-bottom: 12px;
			border: 1px solid #d9d9d9;
			border-radius: 4px;
			cursor: pointer;
			transition: all 0.2s;

			&:last-child {
				margin-bottom: 0;
			}

			&:hover {
				border-color: #1890ff;
				box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);

				.m-address-item-arrow {
					color: #1890ff;
					opacity: 1;
					transform: translateX(0);
				}
			}

			&.m-active {
				border-color: #1890ff;
				box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);

				.m-address-item-check {
					display: flex;
				}
			}

			.m-address-item-info {
				flex: 1;
				min-width: 0;

				.m-address-item-text {
					display: flex;
					align-items: flex-start;
					font-size: 14px;
					font-weight: 500;
					color: #333;
					line-height: 22px;
					margin-bottom: 6px;

					.tf-address {
						flex-shrink: 0;
						margin: 3px 6px 0 0;
						color: #1890ff;
						font-size: 15px;
					}
				}

				.m-address-item-contact {
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					font-size: 13px;
					color: #666;

					.m-contact-item {
						display: inline-flex;
						align-items: center;
						margin-right: 18px;

						.tf {
							margin-right: 4px;
							color: #bfbfbf;
							font-size: 13px;
						}
					}
				}
			}

			.m-address-item-tag {
				position: absolute;
				top: 0;
				right: 0;
				padding: 2px 10px;
				font-size: 12px;
				line-height: 18px;
				color: #fff;
				background: #1890ff;
				border-radius: 0 4px 0 12px;
			}

			.m-address-item-arrow {
				position: absolute;
				top: 50%;
				right: 14px;
				margin-top: -7px;
				color: #d9d9d9;
				font-size: 14px;
				opacity: 0;
				transform: translateX(-4px);
				transition: all 0.2s;
			}

			.m-address-item-check {
				position: absolute;
				right: 0;
				bottom: 0;
				width: 22px;
				height: 22px;
				display: none;
				align-items: center;
				justify-content: center;
				background: #1890ff;
				border-radius: 12px 0 4px 0;

				.tf-check {
					color: #fff;
					font-size: 12px;
				}
			}
		}

		.m-address-empty {
			padding: 40px 0;
			text-align: center;

			.m-address-empty-img {
				width: 120px;
				opacity: 0.8;
			}

			.m-address-empty-text {
				margin-top: 8px;
				color: #999;
				font-size: 14px;
			}
		}
	}
</style>
